import { put, take, takeEvery } from 'redux-saga/effects';
import { toSuccess } from 'react-async-client';

import { GET_SCENARIO_AUTH, GET_METRO_AUTH, LOGOUT } from 'constants/actionTypes';
import { getScenarioAuth, getMetroAuth } from 'actions/asyncActions';
import { handleLinkTokenChange, handleTokenChange } from 'utils/token';

export default function* scenarioLink() {
    yield takeEvery([GET_SCENARIO_AUTH, GET_METRO_AUTH], function () {
        handleTokenChange(null);
    });

    yield takeEvery([toSuccess(GET_SCENARIO_AUTH), toSuccess(GET_METRO_AUTH)], function (action) {
        handleLinkTokenChange(action.payload.token);
    });
}

export const authLogoutSaga = function* () {
    const action = yield take(LOGOUT);
    yield put(getScenarioAuth.error(action.payload));
    yield put(getMetroAuth.error(action.payload));
};

